import React from 'react';
import WorkerManagement from '../../components/workers/WorkerManagement';

const WorkerManagementPage: React.FC = () => {
  return <WorkerManagement farmId="YOUR_FARM_ID_HERE" />;
};

export default WorkerManagementPage; 